// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"0c941194","163":"7a096858","227":"32915e60","264":"b40dc3aa","306":"3e7306a8","322":"5d4c535d","486":"8ff49d9e","625":"94ea5eaf"}[chunkId] + ".css";
};